module.exports = __webpack_public_path__ + "static/icons/icon-map--canada-5e6c1f7d1d589e7603d12050d1f1f7b6.svg";